import i18n from 'src/i18n.js';
const t = (key) => i18n.t(key);

export const accDetailsTabs = () => [
    { id: 'accountDetails', label: t('ConsignmentAdd.submit.accountDetails') },
    { id: 'shipToAddress', label: t('accounts.shipToAddress.shipToAddresses') },
    {
        id: 'associatedPhysicians',
        label: i18n.t('accounts.associatedPhysicians.associatedPhysician'),
    },
    { id: 'userAccess', label: t('accounts.userAccess.userAccess') },
    { id: 'notes', label: t('accounts.accountDetailCard.notes') },
];
